export const STORYBOARD_TYPES = {
  SPATIAL: "SPATIAL",
  FLIP_BOOK: "FLIP_BOOK",
  INTERACTIVE_CONTENT: "INTERACTIVE_CONTENT",
  INTERACTIVE_CONTENT_V2: "INTERACTIVE_CONTENT_V2",
  LANDING_PAGE: "LANDING_PAGE",
  RESOURCE_CENTER: "RESOURCE_CENTER",
} as const;

export const INTERACTIVE_CONTENT_TYPES = [
  STORYBOARD_TYPES.INTERACTIVE_CONTENT,
  STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2,
];

export interface FilterOption {
  label: string;
  value: string | null;
  subscriptionKey?: keyof {
    spatialEnabled: boolean;
    flipBookEnabled: boolean;
    interactiveContentEnabled: boolean;
    landingPageEnabled: boolean;
    resourceCenterEnabled: boolean;
  };
}

export const STORYBOARD_TYPE_OPTIONS: FilterOption[] = [
  { label: "All Types", value: null },
  { label: "Spatial", value: STORYBOARD_TYPES.SPATIAL, subscriptionKey: "spatialEnabled" },
  { label: "Flipbook", value: STORYBOARD_TYPES.FLIP_BOOK, subscriptionKey: "flipBookEnabled" },
  {
    label: "Interactive Content",
    value: STORYBOARD_TYPES.INTERACTIVE_CONTENT,
    subscriptionKey: "interactiveContentEnabled",
  },
  {
    label: "Landing Page",
    value: STORYBOARD_TYPES.LANDING_PAGE,
    subscriptionKey: "landingPageEnabled",
  },
  {
    label: "Resource Center",
    value: STORYBOARD_TYPES.RESOURCE_CENTER,
    subscriptionKey: "resourceCenterEnabled",
  },
];

export const STORYBOARD_STATUS_OPTIONS: FilterOption[] = [
  { label: "All Status", value: null },
  { label: "Live", value: "LIVE" },
  { label: "Draft", value: "DRAFT" },
  { label: "Both", value: "BOTH" },
];
